module.exports = function()
{
    this.transactionAccounts = [];
    this.categories = [];
}